import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const editorialRelatedRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const ctas = selector('[data-motion-ctas]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = fadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0)
  }

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = linesRevealAnimation(pretitle, reverse)
    timeline.add(pretitleAnimation.timeline, 0.1)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0.2)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    timeline.add(textAnimation.timeline, 0.3)
  }

  let ctasAnimation: SharedAnimation
  if (ctas) {
    ctasAnimation = fadeRevealAnimation(ctas)
    timeline.add(ctasAnimation.timeline, 0.45)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    mediaAnimation?.revert()
    pretitleAnimation?.revert()
    titleAnimation?.revert()
    textAnimation?.revert()
    ctasAnimation?.revert()
  }
}
